function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.633 1l.255.001c3.034.033 5.379.657 5.379 1.75a.43.43 0 01-.092.266L13 3.239 9.213 9.266v2.245a.433.433 0 01-.117.296l-.062.055-2.476 1.795a.433.433 0 01-.687-.351V9.01L2.067 2.98a.433.433 0 01-.06-.15L2 2.752C2 1.628 4.477 1 7.633 1zM3.436 3.529L6.67 8.655c.03.046.05.097.06.15l.007.08v3.57l1.61-1.166V9.143c0-.054.01-.108.03-.158l.036-.072 3.376-5.37c-.95.319-2.457.525-4.156.525-1.724 0-3.251-.212-4.197-.54zm4.439-1.66h-.491c-2.236.03-4.118.463-4.461.783l-.024.025.046.073h9.341l.005-.008.062-.08-.009-.01c-.344-.32-2.23-.754-4.47-.784z",
  fill: "currentColor"
});

var SvgIconFilter = function SvgIconFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_filter.79996a02.svg";
export { ForwardRef as ReactComponent };